import * as t from "react";
const n = /* @__PURE__ */ t.createContext(null);
function o() {
  return t.useContext(n);
}
function s() {
  const e = o();
  return (e == null ? void 0 : e.$$material) ?? e;
}
export {
  n as T,
  o as a,
  s as u
};
//# sourceMappingURL=index-B1qvqCCQ.mjs.map
